import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flatten(_this__u8e3s4) {
  var root = _this__u8e3s4;
  return new (flatten$1())(root);
}
function flatten$o$_get_lastUpdatedAt_$ref_5k3toz() {
  return constructCallableReference((p0) => p0.get_lastUpdatedAt_7wjlf3_k$(), 1, 0, 183);
}
var flatten$1Class;
function flatten$1() {
  if (flatten$1Class === VOID) {
    class $ {
      constructor($root) {
        this.$root_1 = $root;
        var tmp = this;
        tmp.$$delegate_0__1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$($root)));
        var tmp_0 = this;
        tmp_0.lastUpdatedAt$delegate_1 = lazy(() => remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$($root).get_lastUpdatedAt_7wjlf3_k$())));
      }
      *modify_ff53f_k$(modification, $completion) {
        return yield* (yield* awaitOnce(this.$root_1, $completion)).modify_ff53f_k$(modification, $completion);
      }
      *delete_4td7nw_k$($completion) {
        return yield* (yield* awaitOnce(this.$root_1, $completion)).delete_4td7nw_k$($completion);
      }
      *set_8ij8r7_k$(value, $completion) {
        return yield* (yield* awaitOnce(this.$root_1, $completion)).set_revjhg_k$(value, $completion);
      }
      set_revjhg_k$(value, $completion) {
        return this.set_8ij8r7_k$(value, $completion);
      }
      get_lastUpdatedAt_7wjlf3_k$() {
        var tmp0 = this.lastUpdatedAt$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('lastUpdatedAt', 1, tmp, flatten$o$_get_lastUpdatedAt_$ref_5k3toz(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_state_82htyv_k$() {
        return this.$$delegate_0__1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_82htyv_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1, 0]);
    flatten$1Class = $;
  }
  return flatten$1Class;
}
//region block: exports
export {
  flatten as flatten190t3gjqiixdz,
};
//endregion

//# sourceMappingURL=ModelCacheReadable.mjs.map
